import RequestBase from './RequestBase';

export class CreateApplicationRequest extends RequestBase {
    constructor(salutation, firstName, lastName, buildingName,
        buildingNumber, streetName, city, postCode,
        country, mobilePhone, dateOfBirth, tradingName,
        businessLandline, yearsTrading, monthlyTurnOver, businessType,
        businessAddress1, businessCity, businessPostcode, businessLegalName) {
        super();
        this._url = '/Applications';
        this.method = 'POST';
        this.contentType = 'application/json';
        this.parameters = [
            'salutation',
            'firstName',
            'lastName',
            'buildingName',
            'buildingNumber',
            'streetName',
            'city',
            'postCode',
            'country',
            'mobilePhone',
            'dateOfBirth',
            'tradingName',
            'businessLandline',
            'yearsTrading',
            'monthlyTurnOver',
            'businessType',
            'businessAddress1',
            'businessCity',
            'businessPostcode',
            'businessLegalName'
        ];
        this.body = {
            'salutation': salutation,
            'firstName': firstName,
            'lastName': lastName,
            'buildingName': buildingName,
            'buildingNumber': buildingNumber,
            'streetName': streetName,
            'city': city,
            'postCode': postCode,
            'country': country,
            'mobilePhone': mobilePhone,
            'dateOfBirth': dateOfBirth,
            'tradingName': tradingName,
            'businessLandline': businessLandline,
            'yearsTrading': yearsTrading,
            'monthlyTurnOver': monthlyTurnOver,
            'businessType': businessType,
            'businessAddress1': businessAddress1,
            'businessCity': businessCity,
            'businessPostcode': businessPostcode,
            'businessLegalName': businessLegalName
        };
    }
}

export class UpdateApplicationRequest extends RequestBase {
    constructor(customerId, buildingName, buildingNumber, streetName,
        city, postCode, country) {
        super();
        this._url = '/Applications';
        this.method = 'POST';
        this.contentType = 'application/json';
        this.parameters = [
            'buildingName',
            'buildingNumber',
            'streetName',
            'city',
            'postCode',
            'country',
            'customerId'
        ];
        this.body = {
            'buildingName': buildingName,
            'buildingNumber': buildingNumber,
            'streetName': streetName,
            'city': city,
            'postCode': postCode,
            'country': country,
            'customerId': customerId
        };
    }
}



// WEBPACK FOOTER //
// ./src/Resources/Applications.js